<template>
  <Modal title="学生对老师评价" v-model="visible">
    <Form ref="recordForm" class="feedback form"
      :label-width="90">
      <Row>
        <Col :span="22">
          <Form-item label="网络状况">
            <label><Rate disabled v-model="feedback.networkStar" :count="feedback.networkStar"></Rate></label>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="上课质量">
            <label><Rate disabled v-model="feedback.qualityStar" :count="feedback.qualityStar"></Rate></label>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="喜欢程度">
            <label><Rate disabled v-model="feedback.likeStar" :count="feedback.likeStar"></Rate></label>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="投诉原因">
            <label>{{ feedback.complaintReasonStr }}</label>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="投诉补充">
            <label>{{ feedback.otherComplaintReason }}</label>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button v-if="feedback.isComplaint === 1" type="text" size="large" @click="cancel">取消投诉</Button>
      <Button type="text" size="large" @click="visible=false">关闭</Button>
    </div>
  </Modal>
</template>
<style>
  .feedback .ivu-form-item {
    margin-bottom: 5px
  }
</style>
<script>
  export default {
    name: 'BookUserFeedbackModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      }
    },
    data () {
      return {
        visible: this.value,
        feedback: {
        }
      }
    },
    methods: {
      cancel () {
        let self = this
        this.$Modal.confirm({
          title: '提示',
          content: '是否<span style="color: red">取消</span>该差评?',
          width: 300,
          okText: '确认关闭',
          loading: true,
          onOk: () => {
            this.$http.post('/bookUserFeedback/canalComplaint', {lsnOpenId: self.openedId}).then(res => {
              if (res) {
                this.$Message.success('更改成功')
                this.$Modal.remove()
                self.value = false
                this.search()
              }
            })
          }
        })
      },
      onLoad () {
        let self = this
        let loadMsg = this.$Message.loading('正在加载中...', 0)
        self.$http.get('/bookUserFeedback/queryByLsnOpenId', { params: {lsnOpenId: self.openedId} }).then(function (res) {
          loadMsg()
          if (!res || !res.data) {
            self.$emit('on-close')
            return
          }
          self.visible = true
          self.feedback = res.data
          let complaintReason = res.data.complaintReason.split(',')
          let complaintReasonArr = []
          complaintReason.forEach(element => {
            let reason = self.$constant.getEnum(self.$constant.complaintReason, parseInt(element))
            complaintReasonArr.push(reason && reason.text)
          })
          self.feedback.complaintReasonStr = complaintReasonArr.join('，')
        })
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.onLoad()
        } else {
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BookUserFeedbackModal.vue?0c320b84